import store from '@/store';

let hasTriedReloadingConfig = false;

export default function getProductPriceFromRates({ product, ratePlans, multiplyBy = 1, familyCrmItemPrice = null }) {
  const id = product?.fields['CRM Item']?.value;
  if (!id) return null;

  if (typeof multiplyBy !== 'number' || multiplyBy <= 0) multiplyBy = 1;
  if (typeof familyCrmItemPrice !== 'number' || familyCrmItemPrice <= 0) familyCrmItemPrice = null;

  const rateplan = ratePlans.find((f) => f.crmId === id);

  // if we can't map the product crm id to one of the rateplans in config it will return undefinded
  // this will result in the SubscriptionList component showing NaN as a price
  if (!rateplan && !hasTriedReloadingConfig) {
    console.warn(`Could not find rateplan with id ${id}, trying to reload config...`);
    // we can try to reload config in order to fetch newest rateplans
    store.dispatch('config/reloadConfig', true);
    // but only try to reload config once to prevent infinite loop
    hasTriedReloadingConfig = true;
  }

  // if we still cant find the rateplan after reloading its because its missing in the config
  if (!rateplan) return '';

  let price = Math.round(rateplan?.price);
  if (multiplyBy > 1 && familyCrmItemPrice) price = price + familyCrmItemPrice * multiplyBy;
  return price;
}
